import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgClass } from '@angular/common';

import { NgbDropdownModule, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import Keycloak, { KeycloakProfile } from 'keycloak-js';

import { AuthenticationService } from '../../utilities/services/authentication.service';
import { JourneyService } from '../../utilities/services/journey.service';
import { CommonService } from '../../utilities/services/common.service';
import { SpinnerLoaderDirective } from '../../utilities/directives/spinner-loader.directive';
import { Journey } from '../../utilities/models/journey.model';

@Component({
    selector: 'console-header',
    imports: [NgbPopover, RouterLink, NgClass, SpinnerLoaderDirective, NgbDropdownModule],
    templateUrl: './console-header.component.html',
    styleUrls: ['./console-header.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ConsoleHeaderComponent implements OnInit, OnDestroy {
  @Output() switchChat = new EventEmitter<any>();
  @Input() openChat!: boolean;
  @Output() switchGlossary = new EventEmitter<any>();
  @Input() openGlossary!: boolean;

  private readonly journeyService = inject(JourneyService);
  private readonly commonService = inject(CommonService);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly keycloak = inject(Keycloak);

  user: KeycloakProfile | undefined;

  subscriptions: any = {};

  stretchMenu = false;

  get journeys() {
    return this.journeyService.journeyList;
  }

  get activeJourney() {
    return this.journeyService.journey;
  }

  ngOnInit() {
    this.subscriptions['JourneyList'] = this.journeyService.getJourneysList().subscribe();
    
    this.subscriptions['ToggleMenu'] = this.commonService.onStretchMenu().subscribe((stretchStatus: boolean) => {
      this.stretchMenu = stretchStatus;
    });

    this.keycloak.loadUserProfile().then(user => {
      this.user = user;
    }).catch(err => {
      console.error('Errore nel caricamento del profilo utente:', err);
    });
  }

  ngOnDestroy() {
    Object.keys(this.subscriptions).forEach((key: string) => {
      this.subscriptions[key].unsubscribe();
    });
  }

  switchJourney(journey: Journey) {
    if (journey.id === this.activeJourney?.id) return;
    this.journeyService.setSessionJourney(journey.id);
  }

  toggleMenu(stretchStatus: boolean) {
    this.commonService.switchMenu(!stretchStatus);
  }

  toggleChat(openStatus: boolean) {
    this.openChat = !openStatus;
    this.switchChat.emit(this.openChat);
  }

  logout() {
    this.authenticationService.logout();
  }
}
